import {
  defaultLoadableState,
  LoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import React, { createContext, useMemo, useState, useCallback } from 'react';
import { SuggestedVehicle } from '~/services/home/contracts/SuggestedVehiclesData';

type SuggestedForYouContextType = {
  fetchSuggestedForYouTrigger: number;
  suggestedVehicles: LoadableState<SuggestedVehicle[]>;
  triggerFetchSuggestedForYou: () => void;
};

export const defaultContext: SuggestedForYouContextType = {
  fetchSuggestedForYouTrigger: 0,
  suggestedVehicles: defaultLoadableState<SuggestedVehicle[]>([]),
  triggerFetchSuggestedForYou() {}
};

const SuggestedForYouContext =
  createContext<SuggestedForYouContextType>(defaultContext);

export function SuggestedForYouContextProvider({
  children
}: React.PropsWithChildren) {
  const suggestedVehicles = useLoadableState<SuggestedVehicle[]>([]);

  const [fetchSuggestedForYouTrigger, setTrigger] = useState(
    defaultContext.fetchSuggestedForYouTrigger
  );

  const triggerFetchSuggestedForYou = useCallback(() => {
    setTrigger(Date.now());
  }, []);

  const value = useMemo<SuggestedForYouContextType>(
    () => ({
      fetchSuggestedForYouTrigger,
      suggestedVehicles,
      triggerFetchSuggestedForYou
    }),
    [
      fetchSuggestedForYouTrigger,
      suggestedVehicles,
      triggerFetchSuggestedForYou
    ]
  );

  return (
    <SuggestedForYouContext.Provider value={value}>
      {children}
    </SuggestedForYouContext.Provider>
  );
}

export default SuggestedForYouContext;
